import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useEffect, useState } from "react";
import CommonForm from "../../../components/form/form";
import { useSelector } from "react-redux";
import { _amount_type } from "../../../../utils/common.js";
import {
  createDeduction,
  deleteDeduction,
  getDeductionList,
  updateDeduction,
} from "../../../../services/workspace/deduction.service.js";

const actions_type = {
  DELETE: "DELETE",
  ADD_EDIT: "ADD_EDIT",
};

const items = [{ label: "Manage Deduction", path: "" }];

const deduction_on = [
  { id: "a1", label: "Basic Salary", value: 1 },
  { id: "a2", label: "Gross Salary", value: 2 },
];

const ManageDeduction = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const { limit } = useSelector((state) => state.global);

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    sortingUIProps
  } = useCommonFetch(getDeductionList, {
    dataPath: "deduction.data",
    totalPath: "deduction.meta.total",
    errorMessage: "Failed to fetch deduction data!",
    debounceDelay: 500,
    sortingOptions: [
      { label: "Name", field: "name" },
      { label: "Date", field: "created_at" },
    ],
    sortingModule: "deduction",
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,

    dataTransformer: (data) => {
      if (Array.isArray(data)) { 
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item.uuid,
            className: "",
            sticky: false,
            variant: "text",
            customCases: null,
          },
          name: {
            data: item.name,
            className: "",
            sticky: false,
            variant: "name",
            customCases: null,
          },
          description: {
            data: item.description,
            className: "",
            variant: "text",
            customCases: null,
          },

          type: {
            data:
              _amount_type.find((type) => type.value === item.type)?.label ||
              "",
            value: item.type,
            className: "",
            variant: "select",
            customCases: null,
            options: _amount_type,
          },

          created_at: {
            data: item.created_at,
            className: "",
            sticky: false,
            variant: "date-time",
            customCases: null,
          },

          deduction_on: {
            data:
              deduction_on.find((type) => type.value === item.type)?.label ||
              "",
            value: item.deduction_on,
            className: "",
            variant: "select",
            customCases: null,
            options: deduction_on,
          },

          value: {
            data: item.value,
            className: "",
            sticky: false,
            variant: "number",
            customCases: null,
          },
          status: {
            data: item.status,
            className: "",
            sticky: false,
            variant: "status",
            customCases: null,
          },
          actions: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "",
            customCases: null,
          },
        }));

        const actionButton = {
          delete: (item) => {
            handleDelete(item.id.data, deleteDeduction, {
              successMessage: "Allowance deleted successfully!",
              errorMessage: "Failed to delete allowance!",
            });
          },
          edit: (item) => {
            openModal(item, actions_type.ADD_EDIT);
            const InitialData = {
              name: item.name.data,
              description: item.description.data,
              type: item.type.value,
              deduction_on: item.deduction_on.value,
              id: item.id.data,
              value: item?.value.data,
            };
            setIsEditValue(InitialData);
          },
        };
        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  // Comprehensive form fields
  const comprehensiveFields = [
    {
      name: "name",
      label: "Dudcution Name",
      type: "text",
      placeholder: "Enter name",
      required: true,
    },
    {
      name: "type",
      label: "Type",
      type: "select",
      options: _amount_type,
      required: true,
    },
    {
      name: "value",
      label: "Amount/Percentage",
      type: "number",
      required: true,
    },
    {
      name: "deduction_on",
      label: "Applicale On",
      type: "select",
      options: deduction_on,
      required: true,
    },
    {
      name: "description",
      label: "Description",
      type: "textarea",
      placeholder: "Write Here..",
    },
  ];

  const TableHeaderData = [
    {
      label: "Deduction Name",
      key: "name",
    },
    {
      label: "Type",
      key: "type",
    },

    {
      label: "Amount/Percentage",
      key: "value",
    },
    {
      label: "Applicable On",
      key: "deduction_on",
    },
    {
      label: "Description",
      key: "description",
    },
    {
      label: "Created At",
      key: "created_at",
      varient: "date-time",
    },
    {
      label: "Status",
      key: "status",
    },
  ];

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    // Edit
    if (isEditValue) {
      await handleUpdate(values, isEditValue.id, updateDeduction, {
        successMessage: "Allowance updated successfully!",
        errorMessage: "Failed to update allowance!",
      });
    } else {
      // Create new
      await handleCreate(values, createDeduction, {
        successMessage: "Allowance created successfully!",
        errorMessage: "Failed to create allowance!",
      });
    }

    // alert(`Form submitted successfully in ${testMode} mode!`);
    setSubmitting(false);
    // Reset form after submission
    setTimeout(() => {
      resetForm();
      setIsEditValue();
      // setFormValues({});
    }, 1000);
  };

  // Handle form cancellation
  const handleCancel = () => {

    setIsEditValue(null);
    closeModal();
    // setFormValues({});
    // setTestMode('create');
  };

  useEffect(() => {
  }, [tableData]);

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        onClickAdd={() => openModal("", actions_type.ADD_EDIT)}
        filter={false}
        shorting
        sortingModule="dedcution"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
      />

      <div className={" bg-white"}>
        <CommonTable
        search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
        />

        {action === actions_type.ADD_EDIT && (
          <CommonModal
            modalSize="lg"
            headerTitle={selectedId ? "Edit Deduction" : "Add Deduction"}
            onClose={handleCancel}
            show={action === actions_type.ADD_EDIT}
          >
            {/* Form */}
            <CommonForm
              fields={comprehensiveFields}
              // initialData={testMode === "edit" ? testInitialData : {}}
              initialData={isEditValue ? isEditValue : {}}
              onSubmit={handleSubmit}
              submitButtonText={
                "Submit"
                // testMode === "create" ? "Create User" : "Update User"
              }
              columnsPerRow={1}
              gap="gap-4"
              rowClassName="   "
              fieldClassName="bg-white p-3 rounded shadow-sm"
            />
          </CommonModal>
        )}
      </div>
    </div>
  );
};
export default ManageDeduction;
